<div data-testid="sales-request-add-page" class="p-6 max-w-5xl">
  <h2 class="text-2xl font-semibold text-gray-800 mb-6">
    {{ "distribution.sales_request.create_title" | translate }}
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.series" | translate }} *
      </span>
      <input pInputText data-testid="sales-request-series" [(ngModel)]="series" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.title" | translate }} *
      </span>
      <input pInputText data-testid="sales-request-title" [(ngModel)]="title" />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.schedule_date" | translate }}
      </span>
      <p-datepicker
        data-testid="sales-request-schedule-date"
        [(ngModel)]="scheduleDate"
        dateFormat="dd/mm/yy"
        appendTo="body"
        [showIcon]="true"
      />
    </label>
    <label class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ "distribution.fields.description" | translate }}
      </span>
      <input
        pInputText
        data-testid="sales-request-description"
        [(ngModel)]="description"
      />
    </label>
  </div>

  <div class="flex items-center justify-between mb-2">
    <h3 class="text-lg font-semibold">
      {{ "distribution.fields.items" | translate }}
    </h3>
    <p-button
      icon="pi pi-plus"
      severity="secondary"
      [outlined]="true"
      [label]="'common.actions.add' | translate"
      (onClick)="addLine()"
    />
  </div>

  <table class="w-full mb-6">
    <thead>
      <tr class="text-left text-sm text-gray-600">
        <th class="p-2">{{ "distribution.fields.sku_code" | translate }} *</th>
        <th class="p-2">{{ "distribution.fields.quantity" | translate }} *</th>
        <th class="p-2">{{ "distribution.fields.description" | translate }}</th>
        <th class="p-2"></th>
      </tr>
    </thead>
    <tbody>
      @for (line of lines(); track $index; let i = $index) {
        <tr>
          <td class="p-2">
            <input
              pInputText
              class="w-full"
              [attr.data-testid]="'sales-request-line-sku-' + i"
              [(ngModel)]="line.skuCode"
            />
          </td>
          <td class="p-2">
            <p-inputnumber
              [attr.data-testid]="'sales-request-line-qty-' + i"
              [(ngModel)]="line.quantity"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
            />
          </td>
          <td class="p-2">
            <input pInputText class="w-full" [(ngModel)]="line.description" />
          </td>
          <td class="p-2">
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [disabled]="lines().length === 1"
              (onClick)="removeLine(i)"
            />
          </td>
        </tr>
      }
    </tbody>
  </table>

  <div class="flex gap-2">
    <p-button
      data-testid="sales-request-save-btn"
      [label]="'common.actions.save' | translate"
      [loading]="saving()"
      (onClick)="onSave()"
    />
    <p-button
      severity="secondary"
      [outlined]="true"
      [label]="'common.actions.cancel' | translate"
      (onClick)="onBack()"
    />
  </div>
</div>

<p-toast />
